'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function Pc(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 1024 1024' }, props),
    React.createElement('path', { d: 'M224 736h576V324.8C800 304.48 785.664 288 768 288H256c-17.696 0-32 16.48-32 36.8V672h576v64H224z m-0.96 64H128a64 64 0 0 1-64-64h96V287.68C160 252.544 188.8 224 223.712 224H800.32C835.488 224 864 252.736 864 287.68V736h96a64 64 0 0 1-64 64H223.072z' })
  );
}
Pc.displayName = 'Pc';

module.exports = Pc;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/pc.js
// module id = 197
// module chunks = 0